<template>
	<div class="view-wrapper">
		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Skills" no-body>
					<b-card-body>
						<b-alert show class="mb-0">Set skill ranks in the Planning tab.</b-alert>
					</b-card-body>

					<skills-table>
						<skills-table-row v-for="(skill, skill_name) in list" :key="skill_name"
							:skill="skill_name">
						</skills-table-row>
						<skills-table-row-profession v-for="(profession, professionID) in professions" :key="professionID"
							:profession="professionID">
						</skills-table-row-profession>
					</skills-table>

				</b-card>

			</div>
		</div>
	</div>
</template>

<script>
import SkillsTable from '@/components/skills/SkillsTable.vue'
import SkillsTableRow from '@/components/skills/SkillsTableRow.vue'
import SkillsTableRowProfession from '@/components/skills/SkillsTableRowProfession.vue'

export default {
	components: {
		SkillsTable,
		SkillsTableRow,
		SkillsTableRowProfession,
	},
	computed: {
		list() {
			return this.$store.state.character.skills.list
		},
		professions() {
			return this.$store.state.character.skills.professions
		},
		total() {
			return this.$store.getters['character/skills/total']
		},
		ranks() {
			return this.$store.getters['character/skills/ranks']
		}
	}
}
</script>

<style scoped>

</style>